import { useSyncExternalStore } from 'react';

/**
 * Which auth dialog is open, as a module-level store: the public API is
 * imperative (`useAuthControls().openUserProfile()`, the button components),
 * so opening a React dialog has to be possible from a plain function call.
 * AuthProvider renders the dialogs and subscribes via useAuthDialogs().
 */
export type OpenDialog = 'sign-in' | 'sign-up' | 'profile' | null;

let open: OpenDialog = null;
const listeners = new Set<() => void>();

function set(next: OpenDialog): void {
  open = next;
  listeners.forEach((l) => l());
}

export const authDialogs = {
  openSignIn: () => set('sign-in'),
  openSignUp: () => set('sign-up'),
  openUserProfile: () => set('profile'),
  close: () => set(null),
};

export function useAuthDialogs(): { open: OpenDialog } {
  const current = useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => open,
  );
  return { open: current };
}
